import { Apple, Play } from "lucide-react";

export function StoreButtons({ primary, secondary, testPrefix = "cta", onDownload }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row">
      <button
        data-testid={`${testPrefix}-appstore`}
        onClick={onDownload}
        className="flex items-center justify-center gap-2 rounded-full bg-brand-orange px-7 py-3.5 text-sm font-bold text-white transition-transform duration-200 hover:-translate-y-0.5 active:scale-[0.98]"
      >
        <Apple size={18} />
        {primary}
      </button>
      <button
        data-testid={`${testPrefix}-googleplay`}
        onClick={onDownload}
        className="flex items-center justify-center gap-2 rounded-full border border-white/20 px-7 py-3.5 text-sm font-bold text-white transition-colors duration-200 hover:border-white hover:bg-white/5 active:scale-[0.98]"
      >
        <Play size={18} />
        {secondary}
      </button>
    </div>
  );
}
